

define(['angular', 'squid/module', 'text!./template.html', 'xo-beaver/dist/logger', 'xo-page-components/src/value-props/directive', 'xo-wallet-components/src/pay-upon-invoice/directive'], function (angular, module, template) {

    return angular.module('hermes.page.xo-pay-upon-invoice.directive', ['squid', 'xo-value-props.directive', 'xo-pay-upon-invoice.directive']).directive('xoPayUponInvoicePage', function ($rootScope, $logger) {

        return {
            template: template,

            scope: {
                token: '=?',
                isUnbranded: '=?'
            },

            controller: function controller($scope, $rootScope, $state, $locale) {// eslint-disable-line no-shadow

            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay-upon-invoice/directive.js
// module id = ./pages/xo-pay-upon-invoice/directive.js
// module chunks = 0